import {ActionType, ScreenType, SlidesIds} from '@/config/globalVariables';
import {ISlide} from '@/common/types';

// @ts-ignore
const subdomain: string = process.env.VUE_APP_SUBDOMAIN;
const domain: string = '';

export const slidesData: ISlide[] = [
  {
    id: SlidesIds.startScreen,
    type: ScreenType.choice,
    messageKey: `${SlidesIds.startScreen}-message`,
    actions: [
      {
        text: `${SlidesIds.startScreen}-action-question`,
        type: ActionType.startChat,
        moveTo: SlidesIds.requestToContact,
      },
      {
        text: `${SlidesIds.startScreen}-action-customer`,
        type: ActionType.redirect,
        moveTo: `${domain}support.html`,
        moveToRegional: new Map([
          ['fr', `https://${subdomain}.netwrix.fr/support.html`],
        ]),
        addCookie: {
          startFrom: SlidesIds.redirect_to_support,
        },
      },
      {
        text: `${SlidesIds.startScreen}-action-buy`,
        type: ActionType.redirect,
        moveTo: `${domain}how_to_buy.html`,
      },
      {
        text: `${SlidesIds.startScreen}-action-more-info`,
        type: ActionType.moveTo,
        moveTo: SlidesIds.justSee,
      },
    ],
  },
  {
    id: SlidesIds.justSee,
    type: ScreenType.choice,
    messageKey: `${SlidesIds.justSee}-message`,
    actions: [
      {
        text: `${SlidesIds.justSee}-action-dag`,
        type: ActionType.redirect,
        moveTo: `${domain}data_access_governance.html`,
        addCookie: {
          startFrom: SlidesIds.you_were_redirected,
        },
      },
      {
        text: `${SlidesIds.justSee}-action-security-and-compliance`,
        type: ActionType.redirect,
        moveTo: `${domain}security_and_compliance.html`,
        addCookie: {
          startFrom: SlidesIds.you_were_redirected,
        },
      },
      {
        text: `${SlidesIds.justSee}-action-ad-security-tools`,
        type: ActionType.redirect,
        moveTo: `${domain}active_directory_security_tools.html`,
        addCookie: {
          startFrom: SlidesIds.you_were_redirected,
        },
      },
      {
        text: `${SlidesIds.justSee}-action-PAM`,
        type: ActionType.redirect,
        moveTo: `${domain}privileged_account_manager.html`,
        addCookie: {
          startFrom: SlidesIds.you_were_redirected,
        },
      },
      {
        text: `${SlidesIds.justSee}-action-ransomware`,
        type: ActionType.redirect,
        moveTo: `${domain}encryption_ransomware_threat.html`,
        addCookie: {
          startFrom: SlidesIds.you_were_redirected,
        },
      },
      {
        text: `${SlidesIds.justSee}-action-products`,
        type: ActionType.redirect,
        moveTo: `${domain}products.html`,
        addCookie: {
          startFrom: SlidesIds.you_were_redirected,
        },
      },
    ],
  },

  {
    id: SlidesIds.you_were_redirected,
    type: ScreenType.choice,
    messageKey: `${SlidesIds.you_were_redirected}-message`,
    actions: [],
  },

  {
    id: SlidesIds.redirect_to_support,
    type: ScreenType.choice,
    messageKey: `${SlidesIds.redirect_to_support}-message`,
    actions: [],
  },

  {
    id: SlidesIds.requestToContact,
    type: ScreenType.request_a_call,
    messageKey: `${SlidesIds.requestToContact}-message`,
    actions: [
      {
        text: '',
        type: ActionType.moveTo,
        moveTo: SlidesIds.TYPContactForm,
      },
    ],

  },
  {
    id: SlidesIds.TYPContactForm,
    type: ScreenType.choice,
    messageKey: '',
    dialogs: [],
    actions: [],
  },

  {
    id: SlidesIds.howToAnswer,
    type: ScreenType.choice,
    messageKey: `${SlidesIds.howToAnswer}-message`,
    actions: [
      {
        text: `${SlidesIds.howToAnswer}-action-chat`,
        type: ActionType.moveTo,
        moveTo: SlidesIds.requestToContact,
        id: `${SlidesIds.howToAnswer}-chat`,
      },
      {
        text: `${SlidesIds.howToAnswer}-action-phone`,
        type: ActionType.moveTo,
        moveTo: SlidesIds.requestToContact,
        id: `${SlidesIds.howToAnswer}-phone`,
      },
    ],
  },
];
